/**
 * Log Admin（赤サイト）の権限（LbUser.permission）まわりの定義。
 *
 * 権限の値そのものは API 側の LbUserPerm
 * （log-admin-api/src/unions/lb-user-perm.union.ts）と揃えること。
 */

export const LB_USER_PERM = {
  ADMINISTRATOR: 0, // 管理者: すべての画面を利用できる
  OTHERS: 1 // その他（一般）: 下記の一部画面のみ利用できる
};

/**
 * 「その他（一般）」権限でも利用できる画面のパス。
 * ここに載っていないパスは管理者専用になる。
 * App.js の PrivateRoute の path と同じ文字列で書くこと。
 */
export const GENERAL_ALLOWED_PATHS = [
  "/logbuild/dashboard", // ダッシュボード
  "/download-data", // データ ダウンロード
  "/logbuild/amp", // AMP対応
  "/logbuild/delivery/manuals", // ユーザー配信
  // マイページは権限に関係なく全員が利用できる
  "/logbuild/mypage/profile",
  "/logbuild/mypage/password",
  "/logbuild/mypage/logout"
];

/**
 * 一般権限のユーザーが管理者専用の画面を開こうとしたときの転送先。
 */
export const PERMISSION_FALLBACK_PATH = "/logbuild/dashboard";

/**
 * ログイン中ユーザー（state.auth.user）から権限を取り出す。
 *
 * NOTE: permission は Cosmos DB を直接編集して設定する運用のため、
 *       数値のつもりで "1" のような文字列が入ることがある。
 *       文字列のまま比較すると管理者にも一般にも当てはまらないため、数値へ寄せる。
 *
 * NOTE: 数値として読めない値（"管理者" など）と、値そのものが無い場合は、
 *       安全側に倒して「その他（一般）」として扱う。管理者として扱うと、
 *       権限が壊れていても画面上は正常に見えてしまい誰も気づけないため。
 *       値が無いのは permission を含まない古いトークンでログインしたままの
 *       場合だが、App 起動時の GET /lb-users/me で正しい権限に置き換わる。
 */
export const getLbUserPermission = user => {
  const permission = user ? user.permission : null;

  if (permission === null || permission === undefined || permission === "") {
    return LB_USER_PERM.OTHERS;
  }

  const permissionNum = Number(permission);
  return Number.isFinite(permissionNum) ? permissionNum : LB_USER_PERM.OTHERS;
};

/**
 * 管理者かどうかを判定する。
 */
export const isAdministrator = permission =>
  permission === LB_USER_PERM.ADMINISTRATOR;

/**
 * 指定したパスをその権限で開けるかどうかを判定する。
 */
export const canAccessPath = (permission, path) => {
  if (isAdministrator(permission)) {
    return true;
  }
  return GENERAL_ALLOWED_PATHS.includes(path);
};
